import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useUpdateUserPreference } from 'utils/account/useUpdateUserPreference';

/**
 * Persists `me.preferences.autoSubscribeWorkContainerNotifications`.
 * `null` clears the preference, which restores the subscription prompt.
 */
export const useUpdateAutoSubscribePreference = () => {
  const { t } = useTranslation();
  const { loading, update } = useUpdateUserPreference({
    successMessage: t(
      'common.autoSubscribeUpdateSuccess',
      'Automatic subscription preference updated successfully.'
    ),
    errorMessage: t(
      'common.autoSubscribeUpdateError',
      'Unable to update automatic subscription preference. Please try again.'
    ),
  });

  const updateAutoSubscribePreference = useCallback(
    (autoSubscribeWorkContainerNotifications: boolean | null, options?: { silent?: boolean }) =>
      update({ autoSubscribeWorkContainerNotifications }, options),
    [update]
  );

  return { loading, updateAutoSubscribePreference };
};
